export const logger = {
    isEnabled: true,
    log: function (...args) {
      if (this.isEnabled) {
        console.log(...args);
      }
    },
  };
  